<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import Blok from '../blok.svelte';
	import { editable } from '../editable';
	import PageGrid16 from '../components/pageGrid16.svelte';

	interface Props {
		content: ISbStoryData<{
			eyebrow: string;
			headline: string;
			badges: Array<ISbStoryData['content']>;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<PageGrid16>
	<section
		use:editable={content}
		class="col-span-full grid grid-cols-14 py-12 text-white lg:col-start-2 lg:col-end-[16] lg:my-12 lg:rounded-2xl lg:py-18"
	>
		<div class="col-span-full max-lg:text-center lg:col-start-2 lg:col-end-7">
			{#if content.eyebrow?.length > 0}
				<span class="mb-1 text-[14px]/[160%] opacity-60 lg:text-[16px]/[150%]"
					>{content.eyebrow}</span
				>
			{/if}
			<h1
				class="text-balance text-[24px]/[108%] font-semibold tracking-[-.24px] lg:text-[32px]/[110%] lg:tracking-[-.32px]"
			>
				{content.headline}
			</h1>
		</div>
		<div
			class="col-span-full flex flex-wrap items-center justify-end gap-12 max-lg:mt-12 max-lg:flex-col lg:col-start-8 lg:col-end-[14] lg:gap-14"
		>
			{#each content.badges as badge}
				<div class="h-24">
					<Blok content={badge} />
				</div>
			{/each}
		</div>
	</section>
</PageGrid16>

<style lang="scss">
	section {
		background: linear-gradient(88deg, #193e30 0.62%, #2a5e49 103.61%);
	}
</style>
